import { ViteReactSSG } from "vite-react-ssg";
import { routes } from "@/routes";
import "@/theme/fonts.css";

// Deploy trigger.

const basename = import.meta.env.BASE_URL.replace(/\/$/, "") || "/";

export const createRoot = ViteReactSSG({ routes, basename }, undefined, {
  getStyleCollector: import.meta.env.SSR
    ? () => import("@/emotionCollector").then((module) => module.emotionCollector())
    : null,
});
